import { useEffect, useState } from "react";

import Spinner, { SPINNER_COLOR, SPINNER_SIZE } from "./Spinner";

// Fixed rather than flow-positioned on purpose. A page-level load hands off
// between several owners in a row — the lazy-route Suspense fallback, the login
// page, the OIDC callback, then the destination page's own fetch — and each one
// used to center its spinner inside a different box. The result was a spinner
// that jumped around the screen (and changed size) on every handoff, which is
// most obvious during login. Anchoring to the viewport means every page-level
// spinner lands on the exact same pixel no matter which component rendered it.
const FULL_PAGE_STYLE = {
  alignItems: "center",
  bottom: 0,
  display: "flex",
  justifyContent: "center",
  left: 0,
  // Purely decorative overlay — never swallow clicks on whatever is behind it.
  pointerEvents: "none",
  position: "fixed",
  right: 0,
  top: 0,
  zIndex: 1000,
};

// Renders the site's red spinner, centered in the viewport, but only after
// `delay` ms have passed. The delay avoids the spinner flashing on fast lazy
// route chunk loads / quick data fetches, and is uniform across page-level
// loads so a quick handoff between two of them cannot flicker.
const DelayedSpinner = ({
  delay = 400,
  size = SPINNER_SIZE,
  color = SPINNER_COLOR,
}) => {
  const [visible, setVisible] = useState(delay === 0);

  useEffect(() => {
    if (delay === 0) {
      return undefined;
    }
    const t = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(t);
  }, [delay]);

  if (!visible) {
    return null;
  }

  return (
    <div style={FULL_PAGE_STYLE}>
      <Spinner size={size} color={color} />
    </div>
  );
};

export default DelayedSpinner;
